// Guides landing list. Add a guide by appending an entry; `to: null` renders an honest "Coming soon" row.
// Descriptions are condensed from each destination page's own intro / SEO description.
export const GUIDES = [
  {
    slug: "methodology",
    title: "Methodology and Sources",
    kicker: "How we work",
    to: "/methodology",
    description:
      "Every number on this site carries a source. Our data tiers, sourcing rules, error-correction policy and the corrections we've made this year.",
  },
  {
    slug: "flagships",
    title: "Flagship 50",
    kicker: "Hand-checked programmes",
    to: "/flagships",
    description:
      "Editorially verified flagship undergraduate programmes. Tuition, entry requirements and offer rate cross-checked against each university's own page.",
  },
  {
    slug: "clearing",
    title: "UK Clearing",
    kicker: "Results season",
    to: "/clearing",
    description:
      "UK universities that typically run Clearing, with outcomes, salary and employer context, a grade matcher, hotline links and a live UCAS deep link.",
  },
  {
    slug: "apply",
    title: "How to Apply",
    kicker: "Country primers",
    to: "/apply",
    description:
      "How applying works country by country: deadlines, documents, visa route and tuition ranges for each destination.",
  },
  {
    slug: "value-countries",
    title: "Best Value Countries",
    kicker: "Study destinations",
    to: "/value/countries",
    description:
      "Destinations compared on tuition and living cost, home-fee eligibility, scholarships, post-study work rights and starting salary, turned into a 10-year return and payback period.",
  },
];
